import React, {memo} from 'react';

import './index.scss';
import {onClickHandler} from '../../utils/onclick';

type Props = {
    hash: string;
    onKeyPress: (key: string) => void;
};

export const Numpad = memo(function Numpad({hash, onKeyPress}: Props) {
    return (
        <div className="keypad-wrapper">
            <div className="keypad">
                <span className="pass-span">{hash}</span>
                <div className="keypad-row">
                    <span {...onClickHandler(() => onKeyPress('1'))}>1</span>
                    <span {...onClickHandler(() => onKeyPress('2'))}>2</span>
                    <span {...onClickHandler(() => onKeyPress('3'))}>3</span>
                </div>
                <div className="keypad-row">
                    <span {...onClickHandler(() => onKeyPress('4'))}>4</span>
                    <span {...onClickHandler(() => onKeyPress('5'))}>5</span>
                    <span {...onClickHandler(() => onKeyPress('6'))}>6</span>
                </div>
                <div className="keypad-row">
                    <span {...onClickHandler(() => onKeyPress('7'))}>7</span>
                    <span {...onClickHandler(() => onKeyPress('8'))}>8</span>
                    <span {...onClickHandler(() => onKeyPress('9'))}>9</span>
                </div>
                <div className="keypad-row">
                    <span className="no-style"/>
                    <span {...onClickHandler(() => onKeyPress('0'))}>0</span>
                    <span {...onClickHandler(() => onKeyPress('X'))}>X</span>
                </div>
            </div>
        </div>
    );
});
